import api from './api';

export const podcastService = {
  // Get all podcast
  getAll: async (type = null, includeInactive = false) => {
    const params = {};
    if (type) params.type = type;
    if (includeInactive) params.includeInactive = includeInactive;
    
    const response = await api.get('/podcast', { params });
    return response.data;
  },

  // Get recent podcast
  getRecent: async (limit = 5) => {
    const response = await api.get('/podcast/recent', {
      params: { limit },
    });
    return response.data;
  },

  // Get pinned podcast
  getPinned: async () => {
    const response = await api.get('/podcast/pinned');
    return response.data;
  },

  // Search podcast
  search: async (query) => {
    const response = await api.get('/podcast/search', {
      params: { q: query },
    });
    return response.data;
  },

  // Get podcast by ID
  getById: async (id) => {
    const response = await api.get(`/podcast/${id}`);
    return response.data;
  },

  // Get podcast by slug
  getBySlug: async (slug) => {
    const response = await api.get(`/podcast/slug/${slug}`);
    return response.data;
  },

  // Create podcast (admin)
  create: async (data) => {
    const response = await api.post('/podcast', data);
    return response.data;
  },

  // Update podcast (admin)
  update: async (id, data) => {
    const response = await api.put(`/podcast/${id}`, data);
    return response.data;
  },

  // Delete podcast (admin)
  delete: async (id) => {
    const response = await api.delete(`/podcast/${id}`);
    return response.data;
  },
};

export default podcastService;
